import type { TOC } from '@ember/component/template-only';

import BarLoaderComponent from 'webapp/components/bar-loader';

export interface Args {
	text: string;
}
const BarLoaderFetchOverlayComponent: TOC<Args> = <template>
	<div class="bar-loader-fetch-overlay">
		<div class="bar-loader-fetch-overlay-ct">
			<BarLoaderComponent />
			<p>{{@text}}</p>
		</div>
	</div>
</template>;

export default BarLoaderFetchOverlayComponent;
